import React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

function SellerReportBarChart({data}) {
    return (
        <div style={{ width: '100%', height: 350 }}>
            <ResponsiveContainer>
                <BarChart data={data} margin={{ left: 20 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" 
                    tickFormatter={(month) => month.slice(0, 3)} 
                    />
                    <YAxis hide/>
                    {/* Custom Tooltip to show only one sales value */}
                    <Tooltip
                        content={({ payload }) => {
                            if (payload && payload.length) {
                                const mainBarData = payload.find(item => item.dataKey === "sales");
                                return (
                                    <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "5px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <strong>{mainBarData ? `Month: ${mainBarData.payload.month}` : ''}</strong>
                                        <p className='text-[#05BF02]'>Sales: {mainBarData ? mainBarData.value : 0}</p>
                                    </div>
                                );
                            }
                            return null;
                        }}
                    />
                    {/* Shadow bar on the right side */}
                    <Bar
                        dataKey="sales"
                        fill="#32383F"
                        opacity={0.2}
                        barSize={25}
                        Tooltip='hide' // Ensure shadow bar doesn't trigger tooltip
                        radius={[5, 5, 0, 0]}
                        background={{ fill: "transparent" }}
                        stackId="shadow"
                        shape={({ x, y, width, height }) => (
                            <rect
                                x={x + width + 20} // Move shadow to the right side of the bar
                                y={y + height / 4} // Start shadow halfway down the bar
                                width={width} // Same width as the main bar
                                height={height * 0.75} // 50% height for the shadow
                                fill="#32383F"
                            />
                        )}
                    />
                    {/* Main bar with top corners rounded */}
                    <Bar
                        dataKey="sales"
                        fill="#05BF02"
                        barSize={25}
                        radius={[5, 5, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>

        </div>
    );
}

export default SellerReportBarChart;
